import getManagePathPrefix from "../../tools/getManagePathPrefix";
import { wConsoleMiddleware } from "./middleware/wConsole";
import axios from 'axios';
import getCustomHeaders from "../../tools/getCustomHeaders";
import { hasOwn } from "../../tools/hasOwn";
import { getGlobalConfig } from "../../core/common/config";
import { arrayRemove } from "../../tools/lang";
import compose from 'koa-compose';
import { downloadMiddleware } from "./middleware/download";
import { handleError } from "./middleware/handleError";
import { get, isObject, isObjectLike, pickBy } from "lodash-es";
import { wujiRequest } from "../../core/common/wujiRequest";
import cloneDeep from "lodash-es/cloneDeep";
import { loginExpireCheck } from "./middleware/handleLogin";
import { arraybufferMiddleware } from "./middleware/base64";
import { printLog } from "../../tools/log";
import { useOrInsteadOfInMiddleware } from "./middleware/useOrInsteadOfIn";
import { isFrontEndCgi } from "../../core/common/isFrontEndCgi";
import { compile } from 'path-to-regexp';
import { message } from 'ant-design-vue';
import { frontEndHttpHookMiddleware } from "./middleware/frontEndHttpHook";
import { frontEndHttpLogMiddleware } from "./middleware/frontEndHttpLog";
import projectDnsService from "../projectDnsService";
const wsCodeKey = 'ws-status-code';
function getDisableParamsSerializer() {
  try {
    return get(window, 'GLOBAL_INFO.disableParamsSerializer');
  } catch (error) {
    return false;
  }
}
export class CgiService {
  constructor() {
    this.middlewares = [];
    this.requestCgi = this.requestCgi.bind(this);
    this.registerMiddleware(frontEndHttpLogMiddleware, 'frontEnd');
    this.registerMiddleware(frontEndHttpHookMiddleware, 'frontEnd');
    this.registerMiddleware(wConsoleMiddleware, 'server');
    if (window.location.protocol === 'https:') {
      this.registerMiddleware(loginExpireCheck, 'server');
    }
    this.registerMiddleware(useOrInsteadOfInMiddleware, 'server');
    this.registerMiddleware(downloadMiddleware, 'server');
    this.registerMiddleware(arraybufferMiddleware, 'server');
    this.registerMiddleware(handleError, 'server');
  }
  async debug(projectId, cgiInfo, options = {}) {
    if (isFrontEndCgi(cgiInfo)) {
      return await this.debugFrontEndCgi(cgiInfo, options);
    }
    return await this.debugUpstream(`/api/xy/datasource/access/debug?projectid=${projectId}`, cgiInfo, options);
  }
  async debugPreview(projectId, cgiInfo, options = {}) {
    return await this.debugUpstream(`/api/xy/datasource/access/debugPreview?projectid=${projectId}`, cgiInfo, options);
  }
  async requestCgiWithMiddlewares(ctx) {
    const requestConfig = this.getRequestConfig(ctx);
    Object.assign(ctx, {
      requestConfig
    });
    // 前端数据源的中间件必须和后端数据源的中间件隔离开
    const isFrontEnd = ctx.collection.type === 'frontEndHttp';
    const list = isFrontEnd ? ['frontEnd', 'all'] : ['server', 'all'];
    const middleware = this.middlewares.filter(item => list.includes(item.type)).map(item => item.middleware);
    const request = compose(middleware);
    await request(ctx, this.requestCgi);
    return ctx.response;
  }
  /**
   * 请求数据源
   */
  async requestCgi(ctx) {
    var _requestConfig$baseUR;
    const {
      requestConfig,
      collectionId,
      cgiName
    } = ctx;
    // 给url添加host
    let fixPrefix = (_requestConfig$baseUR = requestConfig.baseURL) !== null && _requestConfig$baseUR !== void 0 ? _requestConfig$baseUR : '';
    if (!/^(http:|https:|\/\/)/.test(fixPrefix)) {
      fixPrefix = `//${location.host}${fixPrefix}`;
    }
    let res;
    if (typeof ctx.beforeRequest === 'function') {
      await ctx.beforeRequest(ctx);
    }
    const disable = getDisableParamsSerializer();
    try {
      const config = {
        ...(disable ? {} : {
          paramsSerializer(params) {
            const query = pickBy(params || {}, val => val !== undefined);
            return new URLSearchParams(query).toString();
          }
        }),
        ...requestConfig,
        withCredentials: true,
        baseURL: fixPrefix
      };
      res = await axios(config);
      ctx.response = res;
    } catch (error) {
      if (error !== null && error !== void 0 && error.response) {
        ctx.response = error === null || error === void 0 ? void 0 : error.response;
      }
      throw error;
    }
    printLog(`数据源请求[${collectionId}/${cgiName}]`, 'request:', requestConfig, 'response:', res);
    // node层收到业务接口返回的http码，如果不是200就报错，避免返回的数据格式有问题（eg: html），导致前端bug
    if (hasOwn(res.headers, wsCodeKey)) {
      const code = Number(res.headers[wsCodeKey]);
      if (code !== 200) {
        const err = new SourceError(`[数据源] 请求失败 ws-status-code:${code}`);
        err.response = res;
      }
    }
    return res;
  }
  /**
   * 注册中间件
   * @param m
   * @returns
   */
  registerMiddleware(m, type = 'server') {
    if (this.middlewares.some(item => item.middleware === m)) {
      throw new Error('数据源中间件不允许重复注册');
    }
    const config = {
      middleware: m,
      type
    };
    this.middlewares.push(config);
    return () => {
      arrayRemove(this.middlewares, config);
    };
  }
  /**
   * 获取请求参数
   * @param ctx
   * @returns
   */
  getRequestConfig(ctx) {
    if (isFrontEndCgi(ctx.cgiInfo)) {
      return this.getFrontEndRequestConfig(ctx);
    }
    return this.getWujiServerRequestConfig(ctx);
  }
  getWujiServerRequestConfig(ctx) {
    const {
      projectId,
      collectionId,
      cgiInfo,
      request,
      cgiName,
      pageId,
      batchEnabled
    } = ctx;
    const {
      type
    } = cgiInfo;
    let url;
    if (batchEnabled) {
      url = `${getManagePathPrefix()}/datasource/collection/request/${projectId}/${pageId}/${collectionId}/batch/${cgiName}`;
    } else {
      url = `${getManagePathPrefix()}/datasource/collection/request/${projectId}/${pageId}/${collectionId}/${cgiName}`;
    }
    const {
      pathPrefix
    } = getGlobalConfig();
    const {
      query,
      headers
    } = request;
    const params = {};
    // 兼容用户url参数可以为对象或数组
    if (isObject(query)) {
      Object.keys(query).forEach(key => {
        const value = query[key];
        if (isObjectLike(value)) {
          try {
            params[key] = JSON.stringify(value);
          } catch (error) {
            params[key] = value;
          }
        } else {
          params[key] = value;
        }
      });
    }
    const requestConfig = {
      baseURL: pathPrefix,
      url,
      method: type,
      params,
      headers: {
        ...headers,
        ...getCustomHeaders()
      }
    };
    if (cgiInfo.type.toLowerCase() === 'post') {
      requestConfig.data = request.body;
    }
    return requestConfig;
  }
  getFrontEndRequestConfig(ctx) {
    var _info$type;
    const {
      cgiInfo,
      request,
      envId,
      cgiName,
      defaultDns
    } = ctx;
    const info = cgiInfo;
    function getDomainInfo() {
      var _target, _projectDefaultDnsInf, _projectDefaultDnsInf2;
      const infoInCgi = {
        host: info.service,
        https: info.https
      };
      let target = [get(info, `envMap.DNS.${envId}`), get(info, 'envMap.DNS.default'), infoInCgi].filter(Boolean).find(item => {
        var _item$host;
        return Boolean((_item$host = item.host) === null || _item$host === void 0 ? void 0 : _item$host.trim());
      });
      if (!target) {
        target = infoInCgi;
      }
      if ((_target = target) !== null && _target !== void 0 && _target.host) {
        return target;
      }
      const projectDefaultDnsInfo = defaultDns || window.xy_runtime_default_dns;
      return {
        host: (_projectDefaultDnsInf = projectDefaultDnsInfo === null || projectDefaultDnsInfo === void 0 ? void 0 : projectDefaultDnsInfo.host) !== null && _projectDefaultDnsInf !== void 0 ? _projectDefaultDnsInf : '',
        https: (_projectDefaultDnsInf2 = projectDefaultDnsInfo === null || projectDefaultDnsInfo === void 0 ? void 0 : projectDefaultDnsInfo.https) !== null && _projectDefaultDnsInf2 !== void 0 ? _projectDefaultDnsInf2 : false
      };
    }
    function getPath() {
      var _get;
      let url = (_get = get(info, `envConfigMap.${envId}.url`)) !== null && _get !== void 0 ? _get : info.url;
      if (info.useParams) {
        try {
          // 使用路由参数 配置的 info.url就不能带有query参数，不然会compile失败
          const [path, ...others] = url.split('?');
          const toPath = compile(path);
          const realPtah = toPath(request.params || {});
          if (others.length) {
            url = [realPtah, ...others].join('?');
          } else {
            url = realPtah;
          }
        } catch (error) {
          message.error(`数据源接口「${cgiName}」请求路径构造失败，请检查路径格式`);
        }
      }
      return url;
    }
    const {
      host,
      https = false
    } = getDomainInfo();
    const path = getPath();
    const method = (_info$type = info.type) !== null && _info$type !== void 0 ? _info$type : 'get';
    const {
      timeout = 3000
    } = info;
    const {
      query,
      body,
      headers
    } = request;
    const url = `http${https ? 's' : ''}://${host}${path}`;
    const config = {
      url,
      method,
      headers: {
        ...headers
      },
      params: query,
      data: body,
      withCredentials: true,
      timeout
    };
    return config;
  }
  async debugUpstream(url, cgiInfo, options = {}) {
    const {
      timeout
    } = cgiInfo;
    const res = await wujiRequest({
      method: 'post',
      headers: {
        'content-type': 'application/json'
      },
      data: {
        cgiInfo: cloneDeep(cgiInfo),
        cgiPluginInfo: options.beforePlugins,
        afterPluginInfo: options.afterPlugins,
        collectionId: options.collectionId,
        cgiId: options.cgiId,
        collection: options.collection
      },
      url,
      timeout: timeout && typeof timeout === 'number' ? timeout + 2000 : 0
    });
    return res;
  }
  async debugFrontEndCgi(cgiInfo, options = {}) {
    var _options$projectId, _options$collection;
    const projectId = (_options$projectId = options.projectId) !== null && _options$projectId !== void 0 ? _options$projectId : '';
    const envId = options.envId || 'dev';
    const defaultDns = await projectDnsService.loadFrontEndDNS(projectId, envId);
    const rawCtx = {
      cgiInfo,
      cgiName: options.cgiId || '',
      collection: options.collection,
      collectionId: options.collectionId || ((_options$collection = options.collection) === null || _options$collection === void 0 ? void 0 : _options$collection.collectionId) || '',
      envId,
      request: cgiInfo.debugParam,
      pageId: 'wuji_internal_ds_debug',
      projectId,
      internal: true,
      defaultDns
    };
    const config = this.getFrontEndRequestConfig(rawCtx);
    const ctx = {
      ...rawCtx,
      requestConfig: config
    };
    try {
      const response = await this.requestCgiWithMiddlewares(ctx);
      const res = {
        cgiInfo,
        debugInfo: response,
        debugLogs: [],
        debugResult: response === null || response === void 0 ? void 0 : response.data,
        originalResult: response === null || response === void 0 ? void 0 : response.data
      };
      return res;
    } catch (error) {
      console.error(error);
      const res = {
        cgiInfo,
        debugInfo: {},
        debugLogs: [],
        debugResult: null,
        originalResult: null,
        debugError: error
      };
      return res;
    }
    // 前端调试需要走middleware
  }
}
class SourceError extends Error {}
export const cgiService = new CgiService();
// 便于线上查找问题
Object.defineProperty(window, '__cgiService', {
  value: cgiService,
  enumerable: true,
  configurable: true
});
//# sourceMappingURL=cgiService.js.map
